export default __webpack_public_path__ + "static/media/markdown.bf9c8004.svg";